import { createContext, type ReactNode, useContext, useState } from 'react';
import { useBangKePhieuXuatTraNCCExport } from './hooks';

interface BangKePhieuXuatTraNCCContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  queryParams: MuaHangRecord | null;
  setQueryParams: (params: MuaHangRecord | null) => void;
}

const BangKePhieuXuatTraNCCContext = createContext<BangKePhieuXuatTraNCCContextValue | null>(null);

export const useBangKePhieuXuatTraNCCContext = () => {
  const context = useContext(BangKePhieuXuatTraNCCContext);
  if (!context) {
    throw new Error('useBangKePhieuXuatTraNCCContext must be used within BangKePhieuXuatTraNCCProvider');
  }
  return context;
};

export const BangKePhieuXuatTraNCCProvider = ({ children }: { children: ReactNode }) => {
  const [queryParams, setQueryParams] = useState<MuaHangRecord | null>(null);
  const { exportToExcel, canExport } = useBangKePhieuXuatTraNCCExport(queryParams);

  return (
    <BangKePhieuXuatTraNCCContext.Provider value={{ exportToExcel, canExport, queryParams, setQueryParams }}>
      {children}
    </BangKePhieuXuatTraNCCContext.Provider>
  );
};
